import React, { useContext } from 'react';
import { trackEvent } from 'helpers/analytics';
import { Select } from '@getro/rombo';

import PageLayout from 'components/layout/Page';

import DatePicker from 'components/atoms/DatePicker';
import FilterWrapper from 'components/molecules/Sidebar/FilterWrapper';
import SidebarFilters from 'components/molecules/Sidebar/SidebarFilters';

import { useSelector } from 'react-redux';
import { activeNetworkSelector } from 'redux/selectors';
import { FiltersContext } from '../context';
import { INTERVALS, METRICS } from '../filtersOptions';
import { Metrics } from './metrics';

const Analytics = () => {
  const { filters, updateFilters, groupedMetrics } = useContext(FiltersContext);
  const activeNetwork = useSelector(activeNetworkSelector);

  const selectedMetric = METRICS.find((m) => m.value === filters.metric.value);
  const handleChange = ({ target }) => {
    const trackEventParams = {
      filter: target.name,
      value: target.value.value,
    };

    if (Array.isArray(trackEventParams.value)) {
      trackEventParams.value = trackEventParams.value.map((v) => v.key).join(', ');
    }
    trackEvent('analytics:filters_change', trackEventParams);

    updateFilters({ [target.name]: target.value });
  };

  const handleDatesChange = ({ startDate, endDate }) => updateFilters({ startDate, endDate });

  return (
    <PageLayout.Sidebar sx={{ mr: '0px', width: '100%', pl: '0px' }}>
      <SidebarFilters title="Configure report">
        <FilterWrapper title="Metric">
          <Metrics
            groupedMetrics={groupedMetrics}
            selectedMetric={selectedMetric}
            handleChange={handleChange}
            activeNetwork={activeNetwork}
          />
        </FilterWrapper>

        <FilterWrapper title="Timeframe">
          <DatePicker startDate={filters.startDate} endDate={filters.endDate} onSelectDates={handleDatesChange} />
        </FilterWrapper>

        <FilterWrapper title="Interval">
          <Select
            name="interval"
            options={INTERVALS}
            onChange={(value) => handleChange({ target: { name: 'interval', value } })}
            disabled={selectedMetric.disableInterval}
            value={filters.interval}
            className="Analytics__interval-filter"
          />
        </FilterWrapper>
      </SidebarFilters>
    </PageLayout.Sidebar>
  );
};

export default Analytics;
